exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "\n.bg-wringers-info{\n    /* background-color: #343a40!important; */\n    background-color: #7F7F7F!important;\n    /* background: linear-gradient(to right,#7F7F7F,red); */\n\n}\n.text-wringers-info{\n    color: #7F7F7F!important;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./ClientApp/app/components/home/home.component.css
// module id = 414
// module chunks = 0